import { SelectFocusContext } from '../../../context'
import { useElementFocusState } from '../../../hooks'

function SelectFocusContextProvider({ children, onBlur, onFocus }) {
  const { focused, handleBlur, handleFocus } = useElementFocusState({
    onBlur,
    onFocus,
  })

  const context = {
    focused,
    handleBlur,
    handleFocus,
  }

  return <SelectFocusContext value={context}>{children}</SelectFocusContext>
}

export default SelectFocusContextProvider
